import React from 'react';
import { PosEventoInfo } from '../../interfaces/Car';
import './selo-pos-evento.css';

interface BlocoRetornoDeGarantiaProps {
  posEvento?: PosEventoInfo | null;
}

/**
 * O bloco que diz, por extenso, qual serviço este atendimento está retomando (at-96).
 *
 * Compartilhado pelos modais de placa, no molde do `ObservacoesAtendimento` (at-54): renderiza
 * **apenas** quando o atendimento é um retorno de garantia.
 *
 * 🔴 A garantia de 90 dias é **só informativa** (decisão do Victor, 09/09/2026): a tela exibe há
 * quantos dias o veículo saiu e nada mais. Não existe prazo validado, nem aviso, nem bloqueio —
 * um veículo entregue há dois anos pode ser cadastrado como pós-evento. Não escrever aqui nada
 * que sugira uma regra que o sistema não tem.
 *
 * ⚠️ Não confundir com a "Previsão de entrega", que é o prazo de PERMANÊNCIA na oficina (também
 * 90 dias, contados de outro marco). Por isso o texto diz "entregue há N dias", nunca "N dias de
 * garantia".
 *
 * ⚠️ Sem data de entrega registrada, o bloco DIZ isso — nunca "há 0 dias", que seria lido como
 * "voltou no mesmo dia".
 */
const BlocoRetornoDeGarantia: React.FC<BlocoRetornoDeGarantiaProps> = ({ posEvento }) => {
  if (!posEvento) return null;

  const dias = posEvento.diasDesdeEntrega;
  const dataEntrega = posEvento.origemEntregueEm
    ? new Date(posEvento.origemEntregueEm).toLocaleDateString('pt-BR')
    : null;

  return (
    <div className="info-section bloco-retorno-garantia">
      <h3>Retorno de garantia</h3>
      <p className="bloco-retorno-garantia-texto">
        {/*
          🔴 at-106: três frases, porque são três situações diferentes, e a do meio é a que o
          Chefe de Oficina precisa ler antes de procurar um histórico que não existe. O texto
          para em "não está no sistema": a causa (oficina externa, serviço anterior ao go-live,
          cadastro que ninguém fez) não é conhecida, e afirmá-la seria inventar.
        */}
        {!posEvento.origemNoSistema
          ? 'Este veículo está voltando para avaliação de um serviço que não está registrado no sistema. Não há atendimento anterior nem vistoria de saída para comparar.'
          : dataEntrega
            ? `Este veículo já passou pela oficina neste serviço e foi entregue em ${dataEntrega}` +
              (dias === null ? '.' : ` (há ${dias} ${dias === 1 ? 'dia' : 'dias'}).`)
            : 'Este veículo está voltando de um serviço anterior. A data de entrega daquele atendimento não foi registrada.'}
      </p>
      {posEvento.origemEventNumber !== null && (
        <p className="bloco-retorno-garantia-texto">
          Evento do serviço original: <strong>{posEvento.origemEventNumber}</strong>
        </p>
      )}
    </div>
  );
};

export default BlocoRetornoDeGarantia;
